"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconKmPerDay100 = function IconKmPerDay100(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M24 6.95c1.6 0 3.17.22 4.677.651l.55-1.923A19 19 0 0 0 24 4.95zm8.991 2.57a17 17 0 0 1 3.621 3.031l1.484-1.341a19 19 0 0 0-4.046-3.387zm7.744 11.425a16.9 16.9 0 0 0-1.47-4.486l1.795-.882c.497 1.01.903 2.063 1.212 3.148l.006-.002a19 19 0 0 1 .721 4.986H43v.244h-.002c-.121 9.319-6.995 17.19-16.24 18.547-9.326 1.368-18.245-4.308-20.955-13.335-2.634-8.77 1.366-18.127 9.423-22.317L14.69 5.35l5.49 1-3.61 4.26-.664-1.859a17 17 0 1 0 25.09 15.302L41 23.76a17 17 0 0 0-.26-2.815zM22 25.62c2.46 0 3.86-1.91 3.86-5.31S24.48 15 22 15s-3.86 1.91-3.86 5.31 1.4 5.31 3.86 5.31m-7.36-.23h1.86V15.2H14V17h.64zm5.4-5.08c0 2.24.72 3.56 2 3.56s1.94-1.32 1.94-3.56-.72-3.55-1.94-3.55S20 18.07 20 20.31zm10.86 5.31c2.46 0 3.86-1.91 3.86-5.31S33.38 15 30.9 15 27 16.92 27 20.31s1.44 5.31 3.9 5.31m-1.96-5.31c0 2.24.72 3.56 2 3.56s1.94-1.32 1.94-3.56-.72-3.55-1.94-3.55-1.99 1.31-1.99 3.55zm-9.23 11.31L21 33.47h2.12l-1.92-2.31 1.58-1.93h-2L19.7 30.8V27H18v6.47h1.71zm3.56-2.39h1.64v.67c.26-.519.8-.836 1.38-.81a1.39 1.39 0 0 1 1.4.91 1.53 1.53 0 0 1 1.49-.91 1.44 1.44 0 0 1 1.53 1.65v2.72h-1.7v-2.15c0-.47-.15-.78-.56-.78s-.68.27-.68.84v2.09H26.2v-2.15c0-.47-.15-.78-.56-.78s-.68.27-.68.84v2.09h-1.7z",
    clipRule: "evenodd"
  })));
};

export { IconKmPerDay100, IconKmPerDay100 as default };
